import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  onSnapshot,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
  where,
} from "firebase/firestore";
import { db } from "./firebase";

const wishlistRef = collection(db, "wishlist");

export function subscribeToWishlist(ownerUserId, callback) {
  const q = query(wishlistRef, where("ownerUserId", "==", ownerUserId), orderBy("createdAt", "desc"));
  return onSnapshot(q, (snap) => {
    callback(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
  });
}

export function addWishlistItem(ownerUserId, data) {
  return addDoc(wishlistRef, {
    ...data,
    ownerUserId,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
}

export function updateWishlistItem(itemId, data) {
  return updateDoc(doc(db, "wishlist", itemId), {
    ...data,
    updatedAt: serverTimestamp(),
  });
}

export function deleteWishlistItem(itemId) {
  return deleteDoc(doc(db, "wishlist", itemId));
}
